import { Button, Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import {
  setActiveProposal,
  setProposalData,
} from "../../../../modules/proposal.slice";
import {
  useGetLifeStyleQuestions,
  useGetProposalDetailsQuery,
  useGetProposalQuestions,
  useUpdateProposalFormData,
} from "../../../../services/Proposal.service";
import FormLabel from "../FormLabel";
import * as yup from "yup";

import moment from "moment";
import FormBuilder from "../../../../components/FormBuilder/FormBuilder";
import { ValidationFactory } from "../../../../components/FormBuilder/FormBuilder.utils";
import ProposalData from "../../../ProposalSummary/components/ProposalData";
const MedicalForm = () => {
  const dispatch = useDispatch();
  const { activeProposal, proposalData } = useTypedSelector(
    (state) => state.proposal
  );

  const { enquiry, isCKYC, product, members, quote_data } = useGetProposalDetailsQuery();
  const { questions } = useGetProposalQuestions();
  const { lifestyleQuestions } = useGetLifeStyleQuestions();
  const Validation = new ValidationFactory();
  const { saveForm } = useUpdateProposalFormData();
  if (activeProposal !== (isCKYC ? 3 : 2) || !questions) return null;
  const validate = Validation.validate(questions);
  const insurerDetails = quote_data?.FORMDATA?.insurer_details || {};
  return (
    <>
      <FormLabel label="Great! Let’s start with proposer details" />

      <Formik
        initialValues={proposalData.medical_details || {}}
        onSubmit={(values) => {
          saveForm({
            ...proposalData,
            medical_details: values,
            from_screen: "medical",
          });
          dispatch(
            setProposalData({
              ...proposalData,
              medical_details: values,
            })
          );
        }}
        validate={validate}
      >
        {({ submitForm, errors, values }) => (
          <Form
          // placeholder={undefined}
          // onPointerEnterCapture={undefined}
          // onPointerLeaveCapture={undefined}
          >
            <Grid container spacing={2}>
              <>
                <FormBuilder questions={questions} />
                {[102, 103, 106, 107].includes(product?.PRODUCTID ?? 0) && (
                  <>
                    <Grid item xs={12}>
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        fontWeight="600"
                        mt={2}
                      >
                        Lifestyle Questions
                      </Typography>
                    </Grid>

                    {(members ?? []).map((member: any) => {
                      const key_name = member.count
                        ? member.relation + member.count
                        : member.relation;

                      return (
                        <div key={key_name} style={{ paddingLeft: "16px" }}>
                          {/* 🔹 Member Relation */}
                          <Grid item xs={12}>
                            <Typography
                              color="text.secondary"
                              textTransform="capitalize"
                              fontWeight="600"
                              fontSize="18px"
                              mb={1}
                            >
                              {insurerDetails?.[key_name]?.first_name}                            </Typography>
                          </Grid>

                          {/* 🔹 Lifestyle Questions per member */}
                          <Grid container spacing={2} mb={2}>
                            <FormBuilder
                              title=""
                              questions={lifestyleQuestions ?? []}
                              parent="lifestyle"
                              member={key_name}
                            />
                          </Grid>
                        </div>
                      );
                    })}
                  </>
                )}


              </>
              <Grid
                item
                xs={12}
                justifyContent="center"
                display="flex"
                my={1}
              >
                <Button
                  size="large"
                  sx={{
                    background: "#FF6024",
                    "&:hover": { background: "#f26d02" },
                  }}
                  variant="contained"
                  onClick={() => submitForm()}
                >
                  Proceed to Nominee Details
                </Button>
              </Grid>
            </Grid>
          </Form>


        )}
      </Formik >
    </>
  );
};

export default MedicalForm;
